import axios from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions'
import URLSearchParams from 'url-search-params'

const queryParams = new URLSearchParams(window.location.search)

export const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  timeout: 60000, // 60 seconds
  withCredentials: true,
  adapter: cacheAdapterEnhancer(axios.defaults.adapter)
})

export const getSessionStatus = () => instance.get('/sso/status')

// TODO remove this once UL used...
export const postSessionBypass = () =>
  instance.post('/sso/bypass', {
    'de-jwt': queryParams.get('de-jwt')
  })

export const postEstimate = data => instance.post('/estimate', data)

export const getQuals = locale => instance.get(`/quals?locale=${locale}`)

export const getLocales = () => instance.get('/quals/locales')

export const getQualTranslations = (locale, localeTo, questionIDs) =>
  instance.get(
    `/quals/translation?locale=${locale}&locale_to=${localeTo}&question_ids=${questionIDs.join()}`
  )

export const getSample = uuid => instance.get(`/sample?uuid=${uuid}`)

export const postSample = data =>
  instance.post('/sample', data, {
    headers: {
      'x-app-origin': queryParams.get('origin')
    }
  })

export const putSampleState = (uuid, state, url) =>
  instance.put(`/sample/${uuid}/state`, { state, url })

export const getReport = ({ status = [], ...otherParams }) => {
  const params = new URLSearchParams()
  status.forEach(s => params.append('status', s))
  Object.entries(otherParams)
    .filter(([_, value]) => value)
    .forEach(([key, value]) => params.append(key, value))
  return fetch(process.env.REACT_APP_API_URL + '/report/stream?' + params, {
    credentials: 'include'
  })
  // return instance.get('/report', { params, timeout: 0 })
}



// WEBPACK FOOTER //
// ./src/utils/api.js